import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  patientId: "",
  patientFullName: "",
  patientUniqueID: "",
  patientFirstName: "",
  patientLastName: "",
};

export const patientStateSlice = createSlice({
  name: "patientState",
  initialState,
  reducers: {
    setPatientId: (state, action) => {
      state.patientId = action.payload;
    },

    setPatientFullName: (state, action) => {
      state.patientFullName = action.payload;
    },

    setPatientUniqueID: (state, action) => {
      state.patientUniqueID = action.payload;
    },

    setPatientFirstName: (state, action) => {
      state.patientFirstName = action.payload;
    },

    setPatientLastName: (state, action) => {
      state.patientLastName = action.payload;
    },

    resetPatient: (state) => {
      state.patientId = initialState.patientId;
      state.patientFullName = initialState.patientFullName;
      state.patientUniqueID = initialState.patientUniqueID;
      state.patientFirstName = initialState.patientFirstName;
      state.patientLastName = initialState.patientLastName;
    },
  },
});

export const {
  setPatientId,
  setPatientFullName,
  setPatientUniqueID,
  setPatientFirstName,
  setPatientLastName,
  resetPatient,
} = patientStateSlice.actions;

export const selectPatientId = (state) => state.patientState.patientId;
export const selectPatientFullName = (state) =>
  state.patientState.patientFullName;
export const selectPatientUniqueID = (state) =>
  state.patientState.patientUniqueID;
export const selectPatientFirstName = (state) =>
  state.patientState.patientFirstName;
export const selectPatientLastName = (state) =>
  state.patientState.patientLastName;

export default patientStateSlice.reducer;
